import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
// material
import { Card, Box } from '@mui/material';
//
import { Map, GeofenceMap, PositionsAnalyse, Add3DElement } from '../../../map';
import ButtonUpgradePro from '../../ButtonUpgradePro';
import { selectAbonnementData } from '../../../createSelectorUtils';
// ----------------------------------------------------------------------

AppReportMap.propTypes = {
  summary: PropTypes.array
};

export default function AppReportMap({ summary }) {
  const abonnement = useSelector(selectAbonnementData);

  return (
    <Card>
      <Box
        sx={{
          height: 600,
          filter: abonnement ? 'none' : 'blur(5px)'
        }}
        dir="ltr"
      >
        <Map disableMapInteraction={!abonnement}>
          <GeofenceMap />
          <Add3DElement />
          <PositionsAnalyse summary={abonnement ? summary : []} />
        </Map>
      </Box>
      {!abonnement && <ButtonUpgradePro />}
    </Card>
  );
}
